import * as Connector from 'shared/connectors/partnerConnector';
import { PARTNER } from 'store/types';

const init = () => ({
  type: PARTNER.GET_ATTACHED_DDIS_INIT,
});

export const success = data => ({
  type: PARTNER.GET_ATTACHED_DDIS_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: PARTNER.GET_ATTACHED_DDIS_FAILURE,
});

const getAttachedDdis = partnerUuid => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getAttachedDdis(partnerUuid);
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getAttachedDdis;
